import _regeneratorRuntime from "/home/vsts/work/1/s/node_modules/babel-preset-react-app/node_modules/@babel/runtime/regenerator";

var __awaiter = this && this.__awaiter || function (thisArg, _arguments, P, generator) {
  function adopt(value) {
    return value instanceof P ? value : new P(function (resolve) {
      resolve(value);
    });
  }

  return new (P || (P = Promise))(function (resolve, reject) {
    function fulfilled(value) {
      try {
        step(generator.next(value));
      } catch (e) {
        reject(e);
      }
    }

    function rejected(value) {
      try {
        step(generator["throw"](value));
      } catch (e) {
        reject(e);
      }
    }

    function step(result) {
      result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected);
    }

    step((generator = generator.apply(thisArg, _arguments || [])).next());
  });
};

import { DEFAULT_DOMAIN } from './constants';

var loadExternalApi = function loadExternalApi(domain) {
  return __awaiter(void 0, void 0, void 0, /*#__PURE__*/_regeneratorRuntime.mark(function _callee() {
    return _regeneratorRuntime.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            return _context.abrupt("return", new Promise(function (resolve, reject) {
              if (window.JitsiMeetExternalAPI) {
                return resolve(window.JitsiMeetExternalAPI);
              }

              var script = document.createElement('script');
              script.async = true;
              script.src = "https://".concat(domain, "/external_api.js");

              script.onload = function () {
                return resolve(window.JitsiMeetExternalAPI);
              };

              script.onerror = function () {
                return reject(new Error("Script load error: ".concat(script.src)));
              };

              document.head.appendChild(script);
            }));

          case 1:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};

var scriptPromise;
/**
 * Injects the external_api.js script for the corresponding domain in DOM
 * and resolves with either the `JitsiMeetExternalApi` class definition or an error
 *
 * @param {string} domain - The domain of the external API
 * @returns {Promise<JitsiMeetExternalApi>} - the JitsiMeetExternalAPI or an error
 */

export var fetchExternalApi = function fetchExternalApi() {
  var domain = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : DEFAULT_DOMAIN;

  if (scriptPromise) {
    return scriptPromise;
  }

  scriptPromise = loadExternalApi(domain);
  return scriptPromise;
};